if (!customElements.get("social-media-highlights-slider")) {
  class SocialMediaHighlightsSlider extends HTMLElement {
    constructor() {
      super();

      /** Store Content Card before initilation */
      this.slideContent = this.querySelector('.section__social-media-highlights--content-card');

      /** Swiper opts & init */
      const swiperOptions = JSON.parse(this.getAttribute('data-swiper-options')) || {};
      const swiperLayout = this.getAttribute("data-swiper-layout") || "default";

      this.sliderItem = this.querySelector('.swiper');

      this.sliderOptions = {
        slidesPerView: 1,
        spaceBetween: swiperOptions.spaceBetweenMobile || 2,
        breakpoints: {
          750: {
            slidesPerView: swiperOptions.slidesPerViewDesktop || 3,
            spaceBetween: swiperOptions.spaceBetweenDesktop || 2
          },
          1100: {
            slidesPerView: swiperOptions.slidesPerViewDesktop || 4,
            spaceBetween: swiperOptions.spaceBetweenDesktop || 2
          }
        },
        on: {
          afterInit: () => {
            this.querySelector(".swiper-smh").removeAttribute("style");
            // ===== BEGIN DUENDE – marquee stall watchdog (tick seed) =====
            this._lastTickAt = Date.now();
            // ===== END DUENDE =====
          },
          // ===== BEGIN DUENDE – marquee stall watchdog (tick events) =====
          //   Record progress on transition boundaries so the watchdog
          //   in init() can tell "stuck" from "slow". Both start AND end
          //   are recorded because a transition that fires `start` but
          //   never `end` (e.g. interrupted by loopFix or visibility
          //   change) still indicates the marquee is moving — we only
          //   want to intervene when neither side has fired for ~2× speed.
          slideChangeTransitionStart: () => { this._lastTickAt = Date.now(); },
          slideChangeTransitionEnd: () => { this._lastTickAt = Date.now(); }
          // ===== END DUENDE =====
        }
      };

      if (swiperOptions.autoplaySpeed != 0 && swiperLayout === "default") {
        this.sliderOptions = {
          speed: swiperOptions.autoplaySpeed || 10000,
          autoplay: {
            delay: 0,
            disableOnInteraction: false,
            // ===== BEGIN DUENDE – marquee no-pause-on-hover =====
            //   Swiper 11's `pauseOnMouseEnter: true` pauses autoplay by
            //   setting the wrapper's transition-duration to 0. With our
            //   continuous-marquee config (delay:0 + speed:7000 + loop)
            //   that snaps a mid-translate wrapper to its current frame,
            //   producing the "abrupt stop" the user reports each time
            //   the cursor crosses the Instagram bar. A decorative
            //   marquee shouldn't pause on hover anyway.
            pauseOnMouseEnter: false
            // ===== END DUENDE =====
          },
          ...this.sliderOptions
        };
      }

      if (swiperLayout === "default" ) {
        this.sliderOptions = {
          loop: true,
          ...this.sliderOptions
        };
      }

      if (swiperLayout === "stacked") {
        this.sliderOptions = {
          navigation: {
            prevEl: ".swiper-button--prev",
            nextEl: ".swiper-button--next"
          },
          ...this.sliderOptions
        };
      }

      if (Shopify.designMode) {
        window.addEventListener('shopify:section:load', this.init.bind(this));
      }
    }

    connectedCallback() {
      this.init();
    }

    // ===== BEGIN DUENDE – marquee stall watchdog cleanup =====
    //   Clear the watchdog interval if the element is removed (Shopify
    //   section reload in editor, or single-page navigation) so we don't
    //   leak timers pointing at a destroyed Swiper instance.
    disconnectedCallback() {
      if (this._stallTimer) {
        clearInterval(this._stallTimer);
        this._stallTimer = null;
      }
    }
    // ===== END DUENDE =====

    init() {
      this.swiper = new Swiper(this.sliderItem, this.sliderOptions);
      this.toggleSlideContentCard();
      // ===== BEGIN DUENDE – marquee stall watchdog =====
      //   Safety net for Swiper 11's autoplay-deadlock with our
      //   delay:0 + waitForTransition:true marquee shape. If neither
      //   slideChangeTransitionStart nor slideChangeTransitionEnd has
      //   fired for ~2× speed AND autoplay believes itself running
      //   AND isn't legitimately paused (tab hidden), assume the
      //   transitionend listener was missed and force a clean restart.
      //   Check cadence = speed/2 (3.5s default) so detection lag is
      //   bounded to one transition cycle.
      if (this._stallTimer) clearInterval(this._stallTimer);
      const speed = this.sliderOptions.speed || 7000;
      this._stallTimer = setInterval(() => {
        const sw = this.swiper;
        if (!sw || !sw.autoplay || !sw.autoplay.running) return;
        if (sw.autoplay.paused) return;
        if (Date.now() - (this._lastTickAt || 0) <= speed * 2) return;
        try {
          sw.autoplay.stop();
          sw.autoplay.start();
        } catch (_) {
          /* swiper may be destroyed mid-restart — ignore */
        }
        this._lastTickAt = Date.now();
      }, Math.max(2000, Math.floor(speed / 2)));
      // ===== END DUENDE =====
    }

    /** Hide / Show Content Card */
    toggleSlideContentCard() {
      // ===== BEGIN DUENDE – keep content card on every viewport (Figma 300:2341) =====
      //   Stock theme removed the content card slide on mobile to match its
      //   single-slide carousel UX (one image full-width per swipe). Our mobile
      //   design is a 2×2 CSS grid with the content card occupying the
      //   bottom-right cell (positioned via `order: 99` in
      //   assets/section-social-media-highlights.css). Removing the slide
      //   defeats that — so we no-op this function entirely.
      // ===== END DUENDE =====
      return;
    }
  }

  customElements.define("social-media-highlights-slider", SocialMediaHighlightsSlider);
}
